export default `
  query consultarCodigoPromocionalParcerias($cod: String!) {
    consultarCodigoPromocionalParcerias(cod: $cod) {
      idProduto
      descProduto
      codSubProduto
      descSubProdCurta
      descSubProdLonga
      codPromocional
      descBonificacaoLonga
      pacoteDefaultBonificacaoSubProd
      dataInicialValidadeCodPromo
      dataFinalValidadeCodPromo
      descTransacaoMensalidadeCurta
      descTransacaoMensalidadeLongo
      valorTarifa
      valorFixoDescontoTarifa
      percentualDescontoTarifa
      numeroMesesBonificacao
      transacaoBonificacao
      tipoTarifa{
          idTipoTarifa
          idTarifa
          descTarifaCurta
      }
      tipoPessoa{
          idTipoPessoa
          descTipoPessoaPermitidaSubProdLonga
          nemotecnicoTipoPessoaPermitidaSubProd
          descTipoPessoaPermitidaSubProdCurta
      }
    }
  }
`;
